import http from '@/services/http';
import apiEndpoints from '@/services/apiEndpoints';

const getDefaultState = () => {
  return {};
};

const state = getDefaultState();
const getters = {};
const mutations = {};
const actions = {
  async getList (_, payload) {
    return await http.get(apiEndpoints.getListEmailLog, payload);
  },
};
export default {
  state,
  mutations,
  actions,
  getters,
};
